module.exports = __webpack_public_path__ + "static/media/DirectoryProIcon.54237025.png";